import { render, staticRenderFns } from "./SinglePostHeader.vue?vue&type=template&id=28362469&"
import script from "./SinglePostHeader.vue?vue&type=script&lang=js&"
export * from "./SinglePostHeader.vue?vue&type=script&lang=js&"
import style0 from "./SinglePostHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports